import { getAuthClient } from '@/plugins/auth-client'
import type { User } from '@/model/user/schema'
import type { GetterTree } from 'vuex'
import type { RootState } from '@/store/state'
import type { AuthState } from './state'

const getters: GetterTree<AuthState, RootState> = {
  isLoggedIn: (): boolean => {
    return Boolean(getAuthClient()?.check())
  },
  currentUser: (): User => {
    return getAuthClient()?.user()
  }
}

export default getters
